import React from 'react'
import '../App.css'
import Bodyminuta from './bodyminuta'
export class Bodyappminutabody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4">
                <Bodyminuta/>
            </div>
        );
    }
}